import i18next from "i18next";
import {initReactI18next} from "react-i18next";

import translationPl from "./translations/pl/translation.json";
import translationEn from "./translations/en/translation.json";

i18next
    .use(initReactI18next)
    .init({
        lng: "pl",
        debug: false,
        resources: {
            pl: {
                translation: translationPl,
            },
            en: {
                translation: translationEn,
            },
        },
    });

export default i18next;